import { HelperResult } from '@openclassrooms/sdk-web';
import type { TrainingPeriod } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useFindTrainingPeriods } = getCRUDHooks({
  entityName: 'userTrainingPeriods',
  find: ({ userId }): HelperResult<TrainingPeriod[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).trainingPeriods.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useFindTrainingPeriods };
